import { FC } from 'react';
import BordRadioSelectDropdown, {
  IBordRadioSelectOption
} from 'components/NudosComponents/BordRadioSelectDropdown/BordRadioSelectDropdown';
import { LANGUAGE_NAMES } from 'types/global';

import './LanguageSelector.scss';

/**
 * Componente selector de idioma usando BordRadioSelectDropdown
 * @param value - Valor del idioma seleccionado
 * @param onChange - Función que se ejecuta al cambiar el idioma
 * @param disabled - Si el selector está deshabilitado
 */
const LanguageSelector: FC<LanguageSelectorProps> = ({ value, onChange, disabled = false }) => {
  const languageOptions: IBordRadioSelectOption[] = [
    { id: '1', label: LANGUAGE_NAMES.SPANISH, value: LANGUAGE_NAMES.SPANISH },
    { id: '2', label: LANGUAGE_NAMES.ENGLISH, value: LANGUAGE_NAMES.ENGLISH },
    { id: '3', label: LANGUAGE_NAMES.PORTUGUESE, value: LANGUAGE_NAMES.PORTUGUESE }
  ];

  return (
    <div className="languageSelector">
      <BordRadioSelectDropdown
        label=""
        options={languageOptions}
        selectedValue={value}
        onValueChange={onChange}
        componentSize="small"
        disabled={disabled}
        variant="compact"
        customClassName="languageSelectorDropdown"
        customClassNameOptionsContainer="customLanguageOptionsContainer"
        customClassNameSelectOption="customLanguageOption"
      />
    </div>
  );
};

interface LanguageSelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default LanguageSelector;
